module.exports = __webpack_public_path__ + "media/images/ellipse-487d4bed249bb317d7d57ec2d40a2601.png";